import React, { useEffect, useState, useRef } from "react";
import AppBar from '@mui/material/AppBar';
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import toastr from 'toastr';
import {
  hidePkgsAct,
  hideTags,
} from "../redux/ctrl/ctrlActions";
import {
  fetchTagCountAct,
  hidePkgNav,
  resetTagsAct,
  fetchTagCancelAct,
  setProjInitAct,
  fTTActSuccAct,
} from "../redux/project/projActions";
import "./index.scss";
import Loader from "../loader";
import TagTree from "./tagTree";
import PrjTagTable from "./tagGrid";
import treeViewCollapse from '../../assets/svg/Tree_view_collapse.svg';
// -------dragger package
import ViewDrawer from "./viewDrawer";
import Draggable from "react-draggable";
import { IconButton } from "@mui/material";
import DynamicBreadcrumbs from "../shared/DynamicBreadcrumbs";
import { showPkgsAct } from "../redux/ctrl/ctrlActions";

import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { FaAnglesRight } from "react-icons/fa6";


const ShowTags = () => {
  const [slctRev, setSlctRev] = useState();
  const ctrlState = useSelector((state) => state.ctrl);
  const profileState = useSelector((state) => state.profile);
  const getPhase = useSelector((state) => state.project.phase);

  const eProj = { ...ctrlState };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  // let history = useHistory();
  const navigate = useNavigate();

  //---search------
  const [findTag, setFindTag] = useState('');
  const handleSearch = (value) => {
    setFindTag(value)
  }
  const [positionFirst, setPositionFirst] = useState({ positionFirstX: 0 });
  const [sidebarState, setSidebarState] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [gridApi, setGridApi] = useState(null);


  const styleSidebar = {
    width: positionFirst.positionFirstX + 250,
    transition: '.2s ease-in-out'
  };

  useEffect(() => {
    if (getPhase === "SUCCESS") {
      setTimeout(() => {
        dispatch(setProjInitAct("INIT"));
      }, 500);
      // setTimeout(() => {dispatch(hideLoader(false));},  500);
      // setTimeout(() => {dispatch(showLoader(false));},  500);
    }
  });

  useEffect(() => {
    if (ctrlState.pkg.active_revision) {
      setSlctRev({
        value: ctrlState.pkg.active_revision,
        label: ctrlState.pkg.active_revision,
      });
    } else {
      setSlctRev({
        value: ctrlState.pkg.max_revision,
        label: ctrlState.pkg.max_revision,
      });
    }

    dispatch(showPkgsAct({ showPkgs: true, data: ctrlState.data }))
  }, []);

  const toggleSidebar = (val) => {
    // ---for dragger-----
    if (!val) setPositionFirst({ positionFirstX: 0 })
    // ---------------
    setSidebarState(val)
  }

  const onDragFirst = (e, data) => {
    if (data.x > 0 && data.x <= 300) {
      setPositionFirst({ positionFirstX: data.x })
    }
  };

  // -----------------------
  const onChangeRev = (e) => {
    if (e.value != slctRev.value) {
      dispatch(fTTActSuccAct([]))
      dispatch(fetchTagCancelAct());
      dispatch(resetTagsAct());
      dispatch(
        fetchTagCountAct({
          pid: ctrlState.pkg.project_id,
          pkgid: ctrlState.pkg.package_id,
          rev: e.value,
          enable: "Y",
          type: "GET_TAGS"
        })
      );
      setSlctRev(e);
    }
  };


  const navHome = () => {
    //setProj(eProj)
    //dispatch(resetPkgsTagsAct())
    dispatch(hidePkgsAct());
    dispatch(hidePkgNav());
    dispatch(hideTags());
    //dispatch(resetPkgsTagsAct())
    // history.push("/")
    navigate("/");

    //setTimeout(() => {history.push("/")},500)
  };

  const navPkgs = () => navigate("/pkgs", { replace: true });


  return (
    <>
      <Loader />

      <AppBar className="headerMain" id="tagsNavbar">



        <Grid container className="marginRow" spacing={1.4}>

          <Grid item md={10} sm={10} xs={10}>

            <h6 className="fntColor" style={{ marginTop: '0px' }}>{(ctrlState.data.project_name?.length > 30 ? ctrlState.data.project_name.substr(0, 29) + '...' : ctrlState.data.project_name) + ' - ' + (ctrlState.data.project_number?.length > 30 ? ctrlState.data.project_number.substr(0, 29) + '...' : ctrlState.data.project_number)}</h6>
            <DynamicBreadcrumbs onHome={navHome} onPackages={navPkgs} />
          </Grid>

          {/* <Grid item md={2} sm={2} xs={2}>
            <IconButton style={{ color: "white" }} onClick={handleClick} aria-describedby={id} aria-label={notificationsLabel(100)}>
              <Badge badgeContent={100} color="secondary">
                <MdNotificationsNone />
              </Badge>
            </IconButton>

          </Grid> */}


        </Grid>

      </AppBar>



      <div className="draggableHide d-flex top-some-space" >

        {sidebarState &&
          <>
            <div
              className={'sidebar'}
              style={styleSidebar}
            >
              <TagTree
                slctRev={slctRev}
                setSearchValue={setSearchValue}
                getsearchValue={searchValue}
                setSidebarState={setSidebarState}
                setFindTag={handleSearch}
                gridApi={gridApi}
              />
            </div>

            {/* for draggable sidebar */}
            <Draggable
              defaultPosition={{ x: 0, y: 0 }}
              position={{ x: positionFirst.positionFirstX }}
              onDrag={onDragFirst}
            >
              <div>
                <ViewDrawer cssDrawer="drawerFirst" cssHandle="handleFirst" />
              </div>
            </Draggable>
          </>
        }


        {!sidebarState &&
          // <div style={{ maxWidth: '55px' }} ><img src={treeViewCollapse} onClick={() => { toggleSidebar(true) }}
          //   className="d-inline ml-auto mx-1" alt="tree-collapse" style={{ cursor: "pointer", transform: "rotateY(180deg)", marginTop: '8px' }}></img></div>
          <div>
            <IconButton sx={{marginTop: '10px'}}  onClick={() => {toggleSidebar(true)}} size='small' >
              <FaAnglesRight />
            </IconButton>
          </div>
        }


        {/* ---------------- */}
        <div style={{ padding: "0px" }} className="container-fluid flex-grow-1 ">
          <PrjTagTable 
            slctRev={slctRev} 
            onChangeRev={onChangeRev} 
            findTag={findTag}
            gridApi={gridApi}
            setGridApi={setGridApi}
            />
        </div>
      </div>
    </>
  );
};

export default ShowTags;
